import Router from "./Router/Router";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import SupportPanel from "./components/support/SupportPanel";
import { CustomerServiceOutlined } from "@ant-design/icons";

export default function AppWithSupport() {
  const { hotelDetails, showSupportIcon } = useSelector((store) => store.login);
  const { isMobileScreen } = useSelector((store) => store.appHeader);
  const [panelOpen, setPanelOpen] = useState(false);

  const showIcon = hotelDetails && showSupportIcon !== false && !isMobileScreen;

  return (
    <>
      <Router />

      {showIcon && (
        <button
          onClick={() => setPanelOpen(true)}
          className="fixed bottom-6 right-6 z-[500] w-12 h-12 rounded-full bg-blue-600 hover:bg-blue-700 text-white shadow-lg flex items-center justify-center transition-colors"
          title="Support"
        >
          <CustomerServiceOutlined style={{ fontSize: 22 }} />
        </button>
      )}

      <SupportPanel open={panelOpen} onClose={() => setPanelOpen(false)} />
    </>
  );
}
